<template>
  <div class="pageMain">
    <full-loading :fullLoadingShow="fullLoadingShow"></full-loading>
    <div class="shadowBox">
      <div class="numberBox">
        <div class="don" v-if="editing">
          <div class="carNum">
             <input type="text" v-model="carNum">
          </div>
          <div class="editBox sure" @click="sureCarNum">
            <span>确认</span>
          </div>
        </div>
        <div class="don" v-else>
          <div class="carNum">
             <input type="text" disabled v-model="carNum">
          </div>
          <div class="editBox" @click="editCarNum">
            <img src="@assets/images/edit.png"/>
            <span>修改车牌</span>
          </div>
        </div>
      </div>
      <div class="itemBox">
        <div class="item">
          <div class="tip">
            停车地点
          </div>
          <div class="cont">
            湖州市汽车总站站前广场停车场
          </div>
        </div>
        <div class="item">
          <div class="tip">
            入场时间
          </div>
          <div class="cont">
            2022/02/16 13:45:55
          </div>
        </div>
        <div class="item">
          <div class="tip">
            入场车道
          </div>
          <div class="cont">
            入口车道1-无牌车
          </div>
        </div>
        <div class="item">
          <div class="tip">
           停车时长
          </div>
          <div class="cont">
            00小时00分00秒
          </div>
        </div>
        <div class="item">
          <div class="tip">
            应缴金额
          </div>
          <div class="cont">
            ¥0.00
          </div>
        </div>
        <div class="item">
          <div class="tip">
            实缴金额
          </div>
          <div class="cont">
            ¥0.00
          </div>
        </div>
      </div>
    </div>
    <div class="tipBox">
      <p>请在支付后30分钟内离场，否则将产生超时费用!</p>
      <p>收费参考:</p>
      <p>暂无</p>
    </div>
    <div class="buttonBox">
      <div class="money">
        ¥ {{ money.toFixed(2) }}
      </div>
      <div class="button">
        <van-button :disabled="disabled"  color="#ff8500" @click="toPay">
          {{buttonTxt}}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   name: "noNumCarPay",
   data(){
     return{
       editing:false,
       money: 0.00,
       carNum:"sVSHJCM8",
      fullLoadingShow: false,
      buttonTxt:"立即支付",
      disabled:false
     }
   },
   methods:{
    toPay(){
      this.$toast.loading({
        message: '支付中...',
        loadingType: 'spinner',
        forbidClick: true,
      })
      this.$router.push("/noNumCarPayResultcc")
    },
    editCarNum(){
      this.editing = true;
    },
    sureCarNum(){
      this.editing = false;
    }
   }
}
</script>

<style scoped>
 .shadowBox{
   margin-left: .15rem;
   margin-right: .15rem;
   margin-top: .25rem;
   box-shadow: 0 0.07rem 0.467rem rgba(0,0,0,.2);
   background-color: #fff;
   padding: .2rem .17rem 0 .17rem;
   border-radius: .03rem;
 }
 .numberBox{
   padding: .25rem 0;
   border-bottom: 1px solid #eee;
 }
 .itemBox{
   padding-top: .18rem;
   height: auto;
   overflow: hidden;
 }
 .itemBox .item{
   padding-bottom: .18rem;
   display: flex;
   justify-content: space-between;
   font-size: .26rem;
   color: #999;
 }
 .tipBox{
   margin-left: .15rem;
   margin-right: .15rem;
   margin-top: .15rem;
   color: #999;
   font-size: .25rem;
 }
 .tipBox p{
   line-height: .37rem;
 }
 .buttonBox{
   position: fixed;
   left: .15rem;
   right: .15rem;
   bottom: .25rem;
   height: .9rem;
   background-color: #F79831;
   border-radius: .05rem;
   display: flex;
 }
  .buttonBox .money{
    display: flex;
    flex: 1;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: .37rem;
  }
    .buttonBox  .button{
      display: flex;
      flex: 1;
      height: 100%;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: .37rem;
  }
  .buttonBox button{
    width: 100%;
    font-size: .32rem;
  }
  .numberBox .don{
    display: flex;
    justify-content: space-between;
  }
  .carNum{
    font-size: .4rem;
    font-weight: bold;
    letter-spacing: .05rem;
    text-transform: uppercase;
  }
  .carNum input {
    font-size: .42rem;
    font-weight: bold;
    letter-spacing: .05rem;
    text-transform: uppercase;
    width: 4.2rem;
  }
  .editBox{
    display: flex;
    align-items: center;
    font-size: .25rem;
    color:#ff8500;
  }
  .editBox img{
    margin-right: .1rem;
    width: .28rem;
  }
  .sure{
    font-size: .32rem;
    letter-spacing: .1rem;
  }
</style>